module.exports = __webpack_public_path__ + "img/CBILogoRed.23f02967.png";